import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const invoiceDataClassName = DataClassName.INVOICE
const invoiceEndpoint = PisaDataClassEndpoint.INVOICE

export function pisaInvoiceDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(invoiceDataClassName, {
    title: invoiceDataClassName,
    restApi: createPisaRestApiConfig(invoiceEndpoint),
    attributes,
  })
}
